import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { SvgIcon } from '../../../web/components/svgs/icons/SvgIcon';
import { baseStyleSheet } from '../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any> {
	className?: string;
	compactLayout?: boolean;
	styles?: StyleDeclarationValue[];
}

class _NavHeaderBackground extends React.PureComponent<IProps> {
	public render() {
		const { className, styles, compactLayout } = this.props;
		return (
			<div
				className={`${css(
					styleSheet.container,
					compactLayout && styleSheet.compactContainer,
					...(styles || [])
				)} nav-header-background ${className || ''}`}
			>
				{!compactLayout && <span className={css(styleSheet.title, baseStyleSheet.truncateText)}>Lev Admin</span>}
				<SvgIcon height={226} onClick={this.onHeaderBackgroundImageClicked} width={200} viewBox='0 0 200 226'>
					<defs>
						<linearGradient id='b-c' x1='94.08%' x2='50%' y1='26.65%' y2='100%'>
							<stop offset='0%' stopColor='#E8F3F9' />
							<stop offset='100%' stopColor='#B6DFF5' />
						</linearGradient>
					</defs>
					<g fill='none' fillRule='evenodd'>
						<mask id='b-b' fill='#fff'>
							<rect id='b-a' width='202' height='226' />
						</mask>
						<g mask='url(#b-b)'>
							<g transform='translate(-17 -37)'>
								<path
									transform={compactLayout ? 'scale(0.5 1) translate(120 0)' : undefined}
									fill='url(#b-c)'
									d='M117,263 C189.819663,263 228.706788,243.114411 228.706788,170.475356 C228.706788,134.677686 232.258649,32.7153217 209,9 C185.063223,-15.4067646 153.788111,18.9507125 116.855124,18.9507125 C78.2182337,18.9507125 36.1158233,-7.41342889 12,19 C-9.33571618,42.3684505 5.00345952,136.377364 5.00345952,170.475356 C5.00345952,243.114411 44.1803366,263 117,263 Z'
								/>
								{!compactLayout && (
									<g transform='translate(6 130)'>
										<path
											fill='#FFF'
											d='M167 .5L196 .5C197.104569.5 198 1.3954305 198 2.5L198 2.5C198 3.6045695 197.104569 4.5 196 4.5L167 4.5C165.895431 4.5 165 3.6045695 165 2.5L165 2.5C165 1.3954305 165.895431.5 167 .5zM184 10.5L209 10.5C210.104569 10.5 211 11.3954305 211 12.5L211 12.5C211 13.6045695 210.104569 14.5 209 14.5L184 14.5C182.895431 14.5 182 13.6045695 182 12.5L182 12.5C182 11.3954305 182.895431 10.5 184 10.5zM2 32.5L29 32.5C30.1045695 32.5 31 33.3954305 31 34.5L31 34.5C31 35.6045695 30.1045695 36.5 29 36.5L2 36.5C.8954305 36.5 1.3527075e-16 35.6045695 0 34.5L0 34.5C-1.3527075e-16 33.3954305.8954305 32.5 2 32.5z'
										/>
										<rect width='13' height='4' x='18' y='13.5' fill='#FFF' rx='2' />
										<path
											fill='#FFF'
											d='M37,22.5 L66,22.5 C67.1045695,22.5 68,23.3954305 68,24.5 L68,24.5 C68,25.6045695 67.1045695,26.5 66,26.5 L37,26.5 C35.8954305,26.5 35,25.6045695 35,24.5 L35,24.5 C35,23.3954305 35.8954305,22.5 37,22.5 Z'
										/>
									</g>
								)}
								<g transform={compactLayout ? 'translate(86 170) scale(0.5)' : 'translate(52 86)'}>
									<circle cx='1.5' cy='39' r='1.5' fill='#00AAE8' />
									<circle cx='108.5' cy='30' r='1.5' fill='#00AAE8' />
									<circle cx='18' cy='4' r='2' fill='#00AAE8' />
									<circle cx='72' cy='17.5' r='1' fill='#00AAE8' />
									<g fill='#00AAE8' transform='translate(91 .5)'>
										<rect width='6' height='2' y='2.5' rx='1' />
										<path
											d='M1,2.5 L5,2.5 C5.55228475,2.5 6,2.94771525 6,3.5 L6,3.5 C6,4.05228475 5.55228475,4.5 5,4.5 L1,4.5 C0.44771525,4.5 6.76353751e-17,4.05228475 0,3.5 L0,3.5 C-6.76353751e-17,2.94771525 0.44771525,2.5 1,2.5 Z'
											transform='rotate(90 3 3.5)'
										/>
									</g>
									<g fill='#00AAE8' transform='translate(20 24.5)'>
										<rect width='6' height='2' y='2.5' rx='1' />
										<path
											d='M1,2.5 L5,2.5 C5.55228475,2.5 6,2.94771525 6,3.5 L6,3.5 C6,4.05228475 5.55228475,4.5 5,4.5 L1,4.5 C0.44771525,4.5 6.76353751e-17,4.05228475 0,3.5 L0,3.5 C-6.76353751e-17,2.94771525 0.44771525,2.5 1,2.5 Z'
											transform='rotate(90 3 3.5)'
										/>
									</g>
									<ellipse cx='70' cy='141.5' fill='#000' fillOpacity='.3' fillRule='nonzero' rx='46' ry='16' />
									<path
										fill='#00AAE8'
										fillRule='nonzero'
										stroke='#00528C'
										strokeWidth='4'
										d='M93.7416667,76 C92.4544552,93.4730112 92.2516774,106.629874 93.1333333,115.470588 C93.9717455,123.87768 95.4798583,130.779781 97.6576718,136.176891 C98.5331415,137.233956 99,138.348804 99,139.5 C99,146.403559 82.2106781,152 61.5,152 C40.7893219,152 24,146.403559 24,139.5 C24,138.378804 24.4428432,137.292085 25.2734064,136.258218 C26.6533107,132.335005 27.7785147,126.003435 28.65,117.264706 C29.5786013,107.953252 29.5786013,94.1983496 28.65,76 L93.7416667,76 Z'
									/>
									<ellipse cx='60' cy='98.5' fill='#00528C' fillRule='nonzero' rx='33' ry='9' />
									<ellipse cx='61' cy='80.5' fill='#00AAE8' fillRule='nonzero' rx='48' ry='20' />
									<ellipse
										cx='61'
										cy='76.5'
										fill='#00AAE8'
										fillRule='nonzero'
										stroke='#00528C'
										strokeWidth='4'
										rx='48'
										ry='19'
									/>
									<ellipse cx='61' cy='73.5' fill='#00528C' fillRule='nonzero' rx='30' ry='9' />
									<mask
										id='mask0'
										maskUnits='userSpaceOnUse'
										x='0'
										y='1'
										width='74'
										height='56'
										transform='translate(24, 95.5)'
									>
										<path
											fillRule='evenodd'
											clipRule='evenodd'
											d='M0 43C0 42.7591 0.0212682 42.5198 0.0632205 42.2824L3.7 1C3.7 1 11.0114 4.09101 14.8 4.65217C27.201 6.48898 37.6999 6.49758 45.0167 5.86957C59.2 4.65217 70.3 1 70.3 1C70.3 1 69.0239 13.8853 69.6833 21.6957C70.1089 26.7362 71.7831 34.9046 72.917 40.0642C73.6245 41.0044 74 41.9878 74 43C74 43.4172 73.9661 43.8766 73.8905 44.3617C73.9611 44.6629 74 44.8261 74 44.8261L73.8075 44.8213C73.3826 46.8929 72.1963 49.3175 69.6833 50.913C63.2258 55.0131 50.5135 57 37 57C16.5655 57 0 49.7235 0 43Z'
											fill='white'
										/>
									</mask>
									<g mask='url(#mask0)' transform='translate(24, 95.5)'>
										<path
											d='M27 3.77778C27 3.77778 50.3182 6.85859 53.3864 11.7879C56.4545 16.7172 60.0587 38.6902 58.2955 46.2929C56.5322 53.8956 52.7727 56.7677 42.9545 56.7677C33.1364 56.7677 58.2955 58 58.2955 58H81V36.4343L73.6364 -3L27 3.77778Z'
											fill='#4A4A4A'
											fillOpacity='0.3'
										/>
									</g>
									<g fillRule='nonzero' transform='translate(35 6.5)'>
										<path
											fill='#FFF'
											d='M5.48811747,65.4811321 C2.87725956,56.2855209 -0.661791049,50.009434 0.106947516,30.6698113 C0.875686081,11.3301887 5.74436366,0.5 9.3318103,0.5 C11.7234414,0.5 14.5421495,9.52515723 17.7879345,27.5754717 C19.3254116,39.9528302 20.0941502,49.7515723 20.0941502,56.9716981 C20.0941502,67.8018868 20.438113,77.8584906 23.8302196,77.8584906 C27.2223262,77.8584906 27.2223262,63.1692282 28.5502744,52.3301887 C29.8782226,41.4911491 33.0827564,33.5153024 35.4689215,27.5754717 C37.8550866,21.635641 47,22.1603774 47,32.2169811 C47,42.2735849 40.4871998,63.0739252 38.5438758,70.8962264 C37.518891,75.0220126 37.7751372,78.6320755 39.3126143,81.7264151 C32.807775,82.2421384 27.6469767,82.5 23.8302196,82.5 C17.2040545,82.5 12.3712514,81.9842767 9.3318103,80.9528302 C7.79433317,74.2484277 6.51310223,69.091195 5.48811747,65.4811321 Z'
										/>
										<path
											fill='#E8F3F9'
											d='M6.90470208,7.5 C7.80225841,16.3311688 8.80577861,23.8636364 9.91526267,30.0974026 C11.5946045,39.5329815 10.8230985,44.1233766 10.8230985,51.1363636 C10.8230985,53.7337662 10.8230985,59.1883117 10.8230985,67.5 C7.96107845,58.9908876 6.14568601,53.2766019 5.37692121,50.3571429 C3.38865252,42.8064991 3.28261319,37.1145561 3.10775048,34.7727273 C2.60349032,28.0194805 3.86914085,18.9285714 6.90470208,7.5 Z'
										/>
										<path stroke='#979797' />
										<path
											fill='#E8F3F9'
											d='M37,31.319318 C37,35.7773681 48.6,47.7664597 59.475,43.6546743 C66.725,40.913484 67.9333333,39.0860238 63.1,38.1722937 C59.4601696,36.7028329 56.8018363,35.3322378 55.125,34.0605083 C49.2005343,29.5673339 46.8176233,26.41751 44.975,25.8369375 C41.037626,24.5963523 37,26.861268 37,31.319318 Z'
										/>
										<path
											fill='#FFF'
											d='M35,28.593154 C35,33.2609836 46.7424242,44.3791479 58.4848485,42.2265124 C66.3131313,40.791422 68.0255682,39.3563317 63.6221591,37.9212413 C58.469836,34.9475427 55.0449623,32.7949071 53.3475379,31.4633347 C47.3503319,26.7587279 44.9381636,23.4606847 43.0729167,22.8527925 C39.0871998,21.5538299 35,23.9253243 35,28.593154 Z'
										/>
										<path stroke='#979797' />
										<path
											fill='#E8F3F9'
											d='M37.9997556,36.5 C35.9999185,42.2235772 35,47.6869919 35,52.8902439 C35,61.6261741 35.7499389,61.4756098 36.8752139,68.5 C38.7496945,63.8170732 40.2506722,56.7926829 41.0002444,51.3292683 C41.5776919,47.1204213 42.5776104,43.7383075 44,41.1829268 C43.1927131,41.0731231 42.1927946,40.5527979 41.0002444,39.6219512 C39.8076943,38.6911045 38.8075313,37.6504541 37.9997556,36.5 Z'
										/>
									</g>
									<path
										fill='#00AAE8'
										fillRule='nonzero'
										d='M37,80.2891374 C46.8435582,81.5544234 54.0699018,82.2277949 58.6790308,82.3092518 C66.726607,82.4514764 74.3505709,81.5842817 81.5509228,79.7076677 C94.9371155,76.2188498 94.1004785,80.2891374 79.0410116,91.9185304 L43.2747779,92.5 L37,80.2891374 Z'
									/>
									<g fill='#7FD8F8' fillRule='nonzero' transform='translate(47 98.5)'>
										<path d='M15,9.1 L0.726701768,3.5 C0.0807446409,5.86385816 -0.134574402,8.20736644 0.0807446409,10.5305248 C0.296063683,12.8536832 0.943906915,15.1768416 2.02427433,17.5 L15,9.1 Z' />
										<path
											d='M29,6.1 L14.7267018,0.5 C14.0807446,2.86385816 13.8654256,5.20736644 14.0807446,7.53052483 C14.2960637,9.85368322 14.9439069,12.1768416 16.0242743,14.5 L29,6.1 Z'
											transform='rotate(180 21.5 7.5)'
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</SvgIcon>
			</div>
		);
	}

	private onHeaderBackgroundImageClicked = () => {
		const { history } = this.props;
		history.push('/accounts');
	};
}

export const NavHeaderBackground = withRouter(_NavHeaderBackground);
